import { ChevronLeft, ChevronRight } from 'lucide-react';
import { monthLabel } from './month';
import styles from './KpiLeaderboard.module.css';

export interface MonthSwitcherProps {
  months: string[];
  month: string;
  onChange: (month: string) => void;
}

export const MonthSwitcher: React.FC<MonthSwitcherProps> = ({ months, month, onChange }) => {
  const idx = months.indexOf(month);
  const newer = idx > 0 ? months[idx - 1] : null;
  const older = idx >= 0 && idx < months.length - 1 ? months[idx + 1] : null;

  return (
    <div className={styles.monthSwitcher}>
      <button
        type="button"
        className={styles.monthArrow}
        onClick={() => older && onChange(older)}
        disabled={!older}
        aria-label="Предыдущий месяц с начислениями"
      >
        <ChevronLeft size={16} aria-hidden />
      </button>
      <span className={styles.monthLabel}>{monthLabel(month)}</span>
      <button
        type="button"
        className={styles.monthArrow}
        onClick={() => newer && onChange(newer)}
        disabled={!newer}
        aria-label="Следующий месяц с начислениями"
      >
        <ChevronRight size={16} aria-hidden />
      </button>
      {month !== months[0] && (
        <button type="button" className={styles.monthReset} onClick={() => onChange(months[0])}>
          Текущий
        </button>
      )}
    </div>
  );
};
